import PropTypes from 'prop-types';
import {
  Button,
  CircularProgress,
  DialogActions as MuiDialogActions,
} from '@material-ui/core';
import { DIALOG_STEP } from '../consts';

const noop = () => null;

const DialogActions = ({
  disabled,
  isSendBusy,
  onClose,
  onGenerate,
  onSendOtp,
  otpEvent,
  passcode,
  step,
}) => {
  return (
    <MuiDialogActions data-otp-event={otpEvent || ''}>
      {step === DIALOG_STEP.DELIVERY && (
        <>
          <Button color="default" disabled={isSendBusy} onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            disabled={isSendBusy}
            onClick={onSendOtp}
            startIcon={isSendBusy ? <CircularProgress size={16} /> : null}
            variant="contained"
          >
            {isSendBusy ? 'Sending...' : 'Send OTP'}
          </Button>
        </>
      )}
      {step === DIALOG_STEP.CONFIGURE &&
        (passcode ? (
          <Button color="primary" onClick={onClose}>
            Close
          </Button>
        ) : (
          <>
            <Button color="primary" onClick={onClose}>
              Cancel
            </Button>
            <Button color="primary" disabled={disabled} onClick={onGenerate}>
              Generate
            </Button>
          </>
        ))}
    </MuiDialogActions>
  );
};

DialogActions.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isSendBusy: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired,
  onSendOtp: PropTypes.func,
  otpEvent: PropTypes.string,
  passcode: PropTypes.string,
  step: PropTypes.oneOf(Object.values(DIALOG_STEP)),
};

DialogActions.defaultProps = {
  isSendBusy: false,
  onSendOtp: noop,
  otpEvent: undefined,
  passcode: '',
  step: DIALOG_STEP.CONFIGURE,
};

export default DialogActions;
